import { render, staticRenderFns } from "./servicePlan.vue?vue&type=template&id=5d88351c&scoped=true&"
import script from "./servicePlan.vue?vue&type=script&lang=js&"
export * from "./servicePlan.vue?vue&type=script&lang=js&"
import style0 from "./servicePlan.vue?vue&type=style&index=0&id=5d88351c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d88351c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d88351c')) {
      api.createRecord('5d88351c', component.options)
    } else {
      api.reload('5d88351c', component.options)
    }
    module.hot.accept("./servicePlan.vue?vue&type=template&id=5d88351c&scoped=true&", function () {
      api.rerender('5d88351c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ClientDashboard/payments/servicePlan.vue"
export default component.exports